<template>
    <div
        v-if="show"
        @click="toggleShow()"
        class="image-preview-page">
        <span>
            <img
                class="image-employee"
                :src="imagePath">
        </span>
    </div>
</template>

<script>
export default {
    name: 'ImagePreview',

    data () {
        return {
            show: false,
            imagePath: ''
        }
    },

    methods: {
        toggleShow (path) {
            this.imagePath = path
            this.show = !this.show
            if (this.show) {
                this.$nextTick(() => {
                    document.addEventListener('keyup', this.keyUpListener)
                })
            } else {
                this.removeListener()
            }
        },

        keyUpListener (e) {
            if (e.keyCode === 27) { // 27 is button ESC.
                this.show = false
                this.removeListener()
            }
        },

        removeListener () {
            document.removeEventListener('keyup', this.keyUpListener)
        }
    }
}
</script>

<style lang="scss" scoped>
.image-preview-page {
    background-color: #21212152;
    border-color: #21212152;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.image-employee {
    max-height: 600px;
}
</style>
